export interface SortBy {
  timestamp?: boolean;
  source?: boolean;
  metadataKey?: string;
  isAsc: boolean;
}

export type SortByOptionType = 'newest' | 'oldest';

export interface SortByOption {
  label: string;
  value: SortBy;
  type: SortByOptionType;
}

export const sortByOptions: SortByOption[] = [
  {
    label: 'Newest First',
    value: {
      timestamp: true,
      isAsc: false,
    },
    type: 'newest',
  },
  {
    label: 'Oldest First',
    value: {
      timestamp: true,
      isAsc: true,
    },
    type: 'oldest',
  },
];
